import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { VisibilityObserverRootContext } from './context';

export interface VisibilityObserverRootContextProviderProps {
  readonly root: HTMLElement | null;
}

const VisibilityObserverRootContextProvider: FC<PropsWithChildren<VisibilityObserverRootContextProviderProps>> = ({
  root,
  children,
}) => <VisibilityObserverRootContext.Provider value={root}>{children}</VisibilityObserverRootContext.Provider>;

export default VisibilityObserverRootContextProvider;
